import { Component } from 'react';
import Head from 'next/head';
import Box from '@mui/material/Box';
import moment from 'moment';
import 'moment/locale/is';
import Footer from 'src/components/MainLayout/Footer';
import AuthenticatedAppBar from 'src/components/MainLayout/AppBar/AuthenticatedAppBar';

// set locale to icelandic
moment.locale('is');

export default class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <Box
        id="ssas"
        sx={{
          bgcolor: '#f0f0f0',
          px: '16px',
          position: 'relative',
          minHeight: '100vh',
          paddingBottom: '250px',
          '@media print': { pt: '0px' },
        }}
      >
        <Head>
          <title>Greiðendavefur Motus</title>
        </Head>
        <AuthenticatedAppBar />
        <Box
          component="main"
          sx={(theme) => ({
            background: '#f0f0f0',
            pt: '60px',
            '@media print': {
              pt: '0px',
            },
            paddingBottom: '20px',
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            ml: 'auto',
            mr: 'auto',
            maxWidth: '1700px',
          })}
        >
          {children}
        </Box>
        <Box
          sx={(theme) => ({
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            [theme.breakpoints.down('sm')]: {
              bottom: -150,
            },
          })}
        >
          <Footer />
        </Box>
      </Box>
    );
  }
}
